import React, { useEffect, useRef, useState } from 'react';
import config from '../../config';
import { liffGetProfile } from '../../services/promotion/auth.service';
import axios from 'axios';

const liff = window.liff

export const SmartDashboard = ({ redirect }) => {
  const ref = useRef();
  const [dynamicParams, setDynamicParams] = useState('');

  useEffect(() => {
    const initLiffAndFetch = async () => {
        await liff.init({
          liffId: process.env.REACT_APP_LIFF_CLIENT_ID, withLoginOnExternalBrowser: false,
        });
        if (!liff.isLoggedIn()) {
          liff.login({ redirectUri: window.location.href });
          return;
        }

        let profile = await liffGetProfile();
        profile.token = await liff.getAccessToken();

        axios.post(`${process.env.REACT_APP_API_URL}/auth/token`, profile)
          .then(async (res) => {
            axios({
              method: "get",
              url: `${process.env.REACT_APP_API_URL}/customers`,
              headers: {
                Accept: "application/json",
                Authorization: `Bearer ${res.data.token}`
              },
            })
              .then((res) => {
                if (res?.data?.amwayNumber ) {
                    setDynamicParams(`salesPlanAff=200?salesPlanAff=200aboNum=${res?.data?.amwayNumber}partyId=${res?.data?.partyId}`)
                  } 
              })
              .catch((err) => {
                console.log("Customer fetch failed", err);
              });
          })
          .catch(async (err) => {
            console.log("Token fetch failed", err);            
          });
      };

    initLiffAndFetch();
  }, [redirect]);
  
  useEffect(() => {
    if (dynamicParams && ref.current) {
    ref.current.submit();
    }
  }, [dynamicParams]);
  return (
    <div>
      Loading...
      <form
        ref={ref}
        id="appForm"
        method="GET"
        action={`${config.SMARTDASHBOARD_REDIRECT_URI}`}
      >
        <input
          type="hidden"
          name="scope"
          value={dynamicParams}
        />
        <input
          type="hidden"
          name="response_type"
          value="token"
        />
        <input
          type="hidden"
          name="response_mode"
          value="query"
        />
        <input
          type="hidden"
          name="site"
          value="amwaythailand"
        />
        <input
          type="hidden"
          name="client_id"
          id="client_id"
          value={`${config.SMARTDASHBOARD_CLIENTID}`}
        />
        <input
          type="hidden"
          name="redirect_uri"
          id="redirect_uri"
          value={`${config.SMARTDASHBOARD_URL}`}
        />
        <input style={{ display: 'none' }} type="submit" value="submit" />
      </form>
    </div>
  );
};

export default SmartDashboard;
